module.exports = __webpack_public_path__ + "img/header_logo.0e181d31.png";